import type { EventCancellationNotice } from "@tih/shared";
import {
  formatMonthYearKampala,
  formatOrdinalDayInKampala,
  formatWeekdayInKampala,
} from "../lib/eventDisplay";

type Props = {
  notice: EventCancellationNotice;
  /** Tighter spacing when nested under a hero / coming-soon stack. */
  compact?: boolean;
};

export function EventCancellationBanner({ notice, compact = false }: Props) {
  const { day, sup } = formatOrdinalDayInKampala(notice.date);
  const weekday = formatWeekdayInKampala(notice.date);
  const monthYear = formatMonthYearKampala(notice.date);
  const title = notice.title?.trim() || "Worship overnight";

  return (
    <aside
      className={`event-cancel-banner${compact ? " event-cancel-banner--compact" : ""}`}
      role="status"
      aria-live="polite"
    >
      <div className="event-cancel-banner-k">Overnight cancelled</div>
      <div className="event-cancel-banner-title">
        {title}
        <span className="event-cancel-banner-date">
          {weekday}, {day}
          <sup>{sup}</sup> {monthYear}
        </span>
      </div>
      <p className="event-cancel-banner-message">{notice.message}</p>
    </aside>
  );
}
